// extracted by mini-css-extract-plugin
export default {"section":"BackToShopify_section__XyREb","icon":"BackToShopify_icon__fxRDW"};